import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Edge = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M12.094 2.416c-5.5 0-10 4.5-10 10s4.5 10 10 10c3.558 0 6.7-1.883 8.47-4.704a.286.286 0 0 0-.379-.404q-.366.215-.766.358c-1.534.525-2.38.546-3.421.5-1.163-.05-2.58-.45-3.575-1.042-.996-.591-1.813-1.441-2.254-2.179S9.46 13.283 9.58 12.1c.121-1.208 1.225-2.191 2.517-2.191 1.396 0 2.533 1.108 2.533 2.504 0 .708-.337 1.32-.77 1.812-.096.088-.317.405.241.834.663.508 2.15.75 3.33.691 1.178-.058 2.462-.525 3.34-1.45.7-.737 1.326-1.92 1.326-3.225-.004-5.212-4.838-8.658-10.004-8.658'
        fill='currentColor'
      />
    ) : (
      <path
        d='M12.094 2.416c-5.5 0-10 4.5-10 10s4.5 10 10 10c3.558 0 6.7-1.883 8.47-4.704a.286.286 0 0 0-.379-.404q-.366.215-.766.358c-1.534.525-2.38.546-3.421.5-1.163-.05-2.58-.45-3.575-1.042-.996-.591-1.813-1.441-2.254-2.179S9.46 13.283 9.58 12.1c.121-1.208 1.225-2.191 2.517-2.191 1.396 0 2.533 1.108 2.533 2.504 0 .708-.337 1.32-.77 1.812-.096.088-.317.405.241.834.663.508 2.15.75 3.33.691 1.178-.058 2.462-.525 3.34-1.45.7-.737 1.326-1.92 1.326-3.225-.004-5.212-4.838-8.658-10.004-8.658'
        fill='currentColor'
      />
    )}
  </IconBase>
);
